import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { mobileVerification } from "../../../redux/auth/actions";
import { Toaster } from "../../../utils/toaster";
import { useDispatch } from "react-redux";
import { APP_CONST } from "../../../config/const";

import CloseModal from "../../../assets/images/icons/toggle-close.svg";
import ChevronRight from "../../../assets/images/icons/chevron-down.svg";

const MobileNumberVerifyModal = ({ show, handleClose, handleModalShow }) => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [otp, setOtpValue] = useState("");
  const dispatch = useDispatch();

  const getMobileDetails = () => {
    const details =
      localStorage.getItem("mobile_details") &&
      JSON.parse(localStorage.getItem("mobile_details"));
    return details || {};
  };

  const handleSubmit = () => {
    setIsVerifying(true);
    dispatch(mobileVerification({ ...getMobileDetails(), otp }))
      .then((res) => {
        setIsVerifying(false);
        handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.AUTO);
        handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
      })
      .catch((err) => {
        setIsVerifying(false);
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas lgn-reg-modal register"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
      >
        <img src={CloseModal} alt="close modal" />
      </button>

      <Modal.Body>
        <div className="login-section">
          <Modal.Title>Sign up</Modal.Title>

          <div className="form-steps">
            <Form>
              <Form.Group className="form-group" controlId="formBasicPassword">
                <Form.Label>Enter OTP *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter OTP"
                  onChange={(e) => setOtpValue(e.target.value)}
                />
              </Form.Group>

              <div className="modal-btn">
                <Button
                  className="signup"
                  variant="primary"
                  onClick={handleSubmit}
                  disabled={isVerifying}
                >
                  {!isVerifying ? "Verify" : "Submitting..."}
                </Button>
              </div>
            </Form>

            <div className="lgn-sgnup-ac">
              <span>Already have an account?</span>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  handleClose();
                  handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                }}
              >
                Login now
                <img src={ChevronRight} alt="chevron right" />
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MobileNumberVerifyModal;
